"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isH5 = void 0;
const tslib_1 = require("tslib");
const fego_render_1 = tslib_1.__importDefault(require("@futuweb/fego-render"));
const fego_editor_1 = tslib_1.__importDefault(require("@futuweb/fego-editor"));
const PAGE_TYPE_ENUM = {
    H5: 1,
    PC: 10,
};
function isH5() {
    let route = null;
    if (fego_render_1.default) {
        const { store } = fego_render_1.default;
        route = store.route;
    }
    else {
        const { app: { project } } = fego_editor_1.default;
        route = project.route;
    }
    return route.now.pageType === PAGE_TYPE_ENUM.H5;
}
exports.isH5 = isH5;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsK0VBQThDO0FBQzlDLCtFQUE4QztBQUU5QyxNQUFNLGNBQWMsR0FBRztJQUNuQixFQUFFLEVBQUUsQ0FBQztJQUNMLEVBQUUsRUFBRSxFQUFFO0NBQ1QsQ0FBQTtBQUVELFNBQVMsSUFBSTtJQUNULElBQUksS0FBSyxHQUFHLElBQUksQ0FBQztJQUNqQixJQUFJLHFCQUFVLEVBQUU7UUFDWixNQUFNLEVBQ0YsS0FBSyxFQUNSLEdBQUcscUJBQVUsQ0FBQztRQUNmLEtBQUssR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDO0tBQ3ZCO1NBQU07UUFDSCxNQUFNLEVBQ0YsR0FBRyxFQUFFLEVBQ0QsT0FBTyxFQUNWLEVBQ0osR0FBRyxxQkFBVSxDQUFBO1FBQ2QsS0FBSyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUM7S0FDekI7SUFFRCxPQUFPLEtBQUssQ0FBQyxHQUFHLENBQUMsUUFBUSxLQUFLLGNBQWMsQ0FBQyxFQUFFLENBQUM7QUFDcEQsQ0FBQztBQUdHLG9CQUFJIn0=